// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3d2CL","addWidgetButton":"Header_addWidgetButton__1-dbx","dashboardTabs":"Header_dashboardTabs__6nPN6","active":"Header_active__GZ_-b"};